import React from "react";
import { EventsContext } from "../context/entity-collections";
import { filter, reverse, sortBy } from "lodash";
import { isDateFuture, isDatePast } from "@shapeable/utils";
export var useEvents = function () {
  return React.useContext(EventsContext) || [];
};
export var useUpcomingEvents = function () {
  return sortBy(filter(useEvents(), function (event) {
    return isDateFuture(event.startDate);
  }), 'startDate');
};
export var usePastEvents = function () {
  return reverse(sortBy(filter(useEvents(), function (event) {
    return isDatePast(event.endDate);
  }), 'startDate'));
};
export var useCurrentEvents = function () {
  return reverse(sortBy(filter(useEvents(), function (event) {
    return isDatePast(event.startDate) && isDateFuture(event.endDate);
  }), 'startDate'));
};